<template>
  <div ref="stepsCard" class="steps-box">
    <div v-for="(item, index) in stepsData" :key="index"
      :class="[width == '270' ? 'steps-card' : 'steps-card2',index <= stepsIndex ? 'on' : '']">
      <span>{{ index + 1 }}</span>
      <span>{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Steps",
  props: {
    // 输入框宽度
    width: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      stepsIndex: "",
      stepsData: []
    };
  },
  created() {
    this.stepsIndex = this.$parent.stepsIndex;
    this.stepsData = this.$parent.stepsData;
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.steps-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  .steps-card {
    width: 270px;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.25);
    position: relative;
    span {
      font-size: 14px;
      line-height: 23px;
    }
    span:nth-of-type(1) {
      display: inline-block;
      width: 26px;
      height: 26px;
      text-align: center;
      border: 1px solid rgba(0, 0, 0, 0.25);
      border-radius: 50%;
      margin-right: 10px;
      i {
        font-style: normal;
      }
    }
    span:nth-of-type(2) {
      color: rgba(0, 0, 0, 0.45);
    }
  }
  .steps-card:before {
    width: 105px;
    height: 0.5px;
    content: "";
    background: #e9e9e9;
    margin: 0 30px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
  }
  .steps-card:last-of-type {
    width: auto;
  }
  .steps-card:last-of-type:before {
    width: 0;
  }
  .steps-card.on {
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.85);
    span {
      font-size: 14px;
      line-height: 23px;
    }
    span:nth-of-type(1) {
      display: inline-block;
      width: 26px;
      height: 26px;
      text-align: center;
      border: 1px solid #4777e7;
      color: #4777e7;
      border-radius: 50%;
      margin-right: 10px;
    }
    span:nth-of-type(2) {
      color: #4777e7d9;
    }
  }
  .steps-card.on:before {
    background: #5584ffe0;
  }

  .steps-card2 {
    width: 319px;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.25);
    position: relative;
    span {
      font-size: 14px;
      line-height: 23px;
    }
    span:nth-of-type(1) {
      display: inline-block;
      width: 26px;
      height: 26px;
      text-align: center;
      border: 1px solid rgba(0, 0, 0, 0.25);
      border-radius: 50%;
      margin-right: 10px;
      i {
        font-style: normal;
      }
    }
    span:nth-of-type(2) {
      color: rgba(0, 0, 0, 0.45);
    }
  }
  .steps-card2:before {
    width: 190px;
    height: 0.5px;
    content: "";
    background: #e9e9e9;
    margin: 0 15px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
  }
  .steps-card2:last-of-type {
    width: auto;
  }
  .steps-card2:last-of-type:before {
    width: 0;
  }
  .steps-card2.on {
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.85);
    span {
      font-size: 14px;
      line-height: 23px;
    }
    span:nth-of-type(1) {
      display: inline-block;
      width: 26px;
      height: 26px;
      text-align: center;
      border: 1px solid #4777e7;
      color: #4777e7;
      border-radius: 50%;
      margin-right: 10px;
    }
    span:nth-of-type(2) {
      color: #4777e7d9;
    }
  }
  .steps-card2.on:before {
    background: #5584ffe0;
  }
}
</style>
